import { useState } from "react";
import { Capacitor } from "@capacitor/core";

interface NavigatorStandalone extends Navigator {
  standalone?: boolean;
}

export const useStandaloneMode = () => {
  const [isStandalone] = useState(() => {
    const nav = window.navigator as NavigatorStandalone;
    const isIOSStandalone = nav.standalone === true;
    const isPWAStandalone = window.matchMedia(
      "(display-mode: standalone)",
    ).matches;
    const isNative = Capacitor.isNativePlatform();

    return isIOSStandalone || isPWAStandalone || isNative;
  });

  return isStandalone;
};
